import type { HttpErrorResponse } from '@angular/common/http';

import { createSelector } from '@ngrx/store';

import { createEntityCollectionStore, ngrxEvent, pipeState } from '@core/ngrx-legacy';
import type { SignInConsent } from '@core/tellent-types';

import { EntityStoreKey } from '../types';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<SignInConsent>()(
  EntityStoreKey.TellentGrantAccess,
  {
    customActions: adapter => ({
      grantAccess: state => adapter.markAsPending(state),
      grantAccessSuccess: state => pipeState(state, next => adapter.markAsLoaded(next)),
      grantAccessFail: ngrxEvent<HttpErrorResponse>(),

      revokeAccess: state => adapter.markAsPending(state),
      revokeAccessSuccess: (state, payload: SignInConsent) =>
        pipeState(
          state,
          next => adapter.updateOne(next, payload),
          next => adapter.markAsLoaded(next),
        ),
      revokeAccessFail: ngrxEvent<HttpErrorResponse>(),
    }),
  },
);

const consentList = createSelector(
  selectors.entitiesWithPagination({ scope: 'main' }),
  ({ rows }) => rows || [],
);

const TellentGrantAccessSelectors = {
  ...selectors,
  consentList,
};

export {
  actions as TellentGrantAccessActions,
  TellentGrantAccessSelectors,
  reducer as TellentGrantAccessReducer,
  namespace as TellentGrantAccessNamespace,
};
